import axios from "axios";
import {
  PAYMENT_GATEWAY_API_BASE_URL,
  HOME_BASE_URL,
  TP_API_BASE_URL,
  USEREVENTS_BASE_URL,
} from "@config";

declare module "axios" {
	interface AxiosRequestConfig {
		requireAuth?: boolean;
	}
	interface InternalAxiosRequestConfig {
		requireAuth?: boolean;
	}
}

export const paymentGatewayApi = axios.create({
  baseURL: PAYMENT_GATEWAY_API_BASE_URL,
});

export const homeWebsiteApi = axios.create({
  baseURL: HOME_BASE_URL,
});

export const tpApi = axios.create({
  baseURL: TP_API_BASE_URL,
});

export const userEventsApi = axios.create({
  baseURL: USEREVENTS_BASE_URL,
});

export const authEnabledInstances = [paymentGatewayApi, homeWebsiteApi, tpApi, userEventsApi];
